import 'bootstrap/dist/css/bootstrap.css';
import './Css/FlexBox.css';
import './Foundation/css/dhicon.css?asdf=4';
import './Foundation/css/animation.css';
import './custom.css'
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, BrowserRouter } from 'react-router-dom';
import App from './App';
import { pdfjs } from 'react-pdf';
import registerServiceWorker, { unregister } from './registerServiceWorker';

//const root = createRoot(document.getElementById('root'));
//root.render(<BrowserRouter><App /></BrowserRouter>);

const router = createBrowserRouter([{ path: "*", element: <App /> }]);

createRoot(document.getElementById('root')).render(<RouterProvider router={router} />);

//registerServiceWorker();
unregister();
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;